import { useMutation, useQuery } from "@tanstack/react-query";
import { ParkSafeApi } from "../Api";
export const useParkSafe = ()=>{
    const parkSafeApi = new ParkSafeApi();
    const useParkSafeQuery = (slug)=>useQuery([
            "park-safe",
            slug
        ], ()=>parkSafeApi.getParkSafe(slug), {
            refetchOnWindowFocus: false
        });
    const useUpdateParkSafe = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return useMutation((data)=>parkSafeApi.approveParkSafe(data), {
            onSuccess,
            onError
        });
    };
    return {
        useUpdateParkSafe,
        useParkSafeQuery
    };
};
